function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#DFDFDF",
    style: (_ref2 = {
      fill: "#DFDFDF"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8763 0.8763 0.8763)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("g", {
    id: "Final Design"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3251 -1174C-3251 -1175.1 -3250.1 -1176 -3249 -1176H5751C5752.1 -1176 5753 -1175.1 5753 -1174V3146C5753 3147.1 5752.1 3148 5751 3148H-3249C-3250.1 3148 -3251 3147.1 -3251 3146V-1174Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3249 -1175H5751V-1177H-3249V-1175ZM5752 -1174V3146H5754V-1174H5752ZM5751 3147H-3249V3149H5751V3147ZM-3250 3146V-1174H-3252V3146H-3250ZM-3249 3147C-3249.55 3147 -3250 3146.55 -3250 3146H-3252C-3252 3147.66 -3250.66 3149 -3249 3149V3147ZM5752 3146C5752 3146.55 5751.55 3147 5751 3147V3149C5752.66 3149 5754 3147.66 5754 3146H5752ZM5751 -1175C5751.55 -1175 5752 -1174.55 5752 -1174H5754C5754 -1175.66 5752.66 -1177 5751 -1177V-1175ZM-3249 -1177C-3250.66 -1177 -3252 -1175.66 -3252 -1174H-3250C-3250 -1174.55 -3249.55 -1175 -3249 -1175V-1177Z",
    fill: "black",
    fillOpacity: 0.1,
    style: {
      fill: "black",
      fillOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Company"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_6949)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -296,
    y: -232,
    width: 1200,
    height: 1715,
    fill: "#F2F4FE",
    style: (_ref3 = {
      fill: "#F2F4FE"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.9490 0.9569 0.9961)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277663",
    clipPath: "url(#clip1_213_6949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1171277595"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -91,
    y: -8,
    width: 127,
    height: 36,
    rx: 18,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow / Caret_Down_SM"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.75 8.54297L10 12.293L6.25 8.54297",
    stroke: "#394DFC",
    style: (_ref4 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_6949"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -296,
    y: -232,
    width: 1200,
    height: 1715,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_213_6949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 979,
    height: 88,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-91 -60)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1a236c8817314343c981a44483f73f81.svg";
export { ForwardRef as ReactComponent };